<template>
  <v-container style="max-width: 480px; padding-top: 4rem">
    <v-card color="surface" class="pa-8">
      <div class="text-center mb-6">
        <v-icon color="primary" size="48" class="mb-2">mdi-dice-multiple</v-icon>
        <h1 class="text-h5 font-weight-bold">Kom i gang</h1>
        <p class="text-body-2 text-grey">Opret din Backgammon Tracker konto</p>
      </div>

      <!-- OAuth -->
      <div class="mb-6">
        <v-btn block size="large" variant="outlined" class="mb-3" @click="$router.push('/login')">
          <v-icon start>mdi-google</v-icon>
          Fortsæt med Google
        </v-btn>
        <v-btn block size="large" variant="outlined" color="white" @click="$router.push('/login')">
          <v-icon start>mdi-apple</v-icon>
          Fortsæt med Apple
        </v-btn>
      </div>

      <div class="d-flex align-center mb-6">
        <v-divider />
        <span class="mx-4 text-caption text-grey">eller med email</span>
        <v-divider />
      </div>

      <v-form @submit.prevent="handleRegister">
        <v-text-field
          v-model="displayName"
          label="Visningsnavn (valgfrit)"
          prepend-inner-icon="mdi-account-outline"
          class="mb-3"
        />
        <v-text-field
          v-model="username"
          label="Brugernavn"
          prepend-inner-icon="mdi-at"
          :rules="[
            (v) => !!v || 'Brugernavn er påkrævet',
            (v) =>
              /^[a-zA-Z0-9_]{3,30}$/.test(v) ||
              '3-30 tegn (bogstaver, tal, underscore)',
          ]"
          class="mb-3"
        />
        <v-text-field
          v-model="email"
          label="Email"
          type="email"
          prepend-inner-icon="mdi-email-outline"
          :rules="[(v) => !!v || 'Email er påkrævet']"
          class="mb-3"
        />
        <v-text-field
          v-model="password"
          label="Adgangskode"
          :type="showPw ? 'text' : 'password'"
          prepend-inner-icon="mdi-lock-outline"
          :append-inner-icon="showPw ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="showPw = !showPw"
          :rules="[
            (v) => !!v || 'Adgangskode er påkrævet',
            (v) => v.length >= 8 || 'Mindst 8 tegn',
          ]"
          class="mb-4"
        />

        <v-btn
          type="submit"
          color="primary"
          size="large"
          block
          :loading="auth.loading"
        >
          Opret konto
        </v-btn>
      </v-form>

      <v-alert
        v-if="error"
        type="error"
        variant="tonal"
        class="mt-4"
        density="compact"
      >
        {{ error }}
      </v-alert>

      <p class="text-center text-body-2 mt-6 text-grey">
        Har du allerede en konto?
        <router-link to="/login" class="text-primary text-decoration-none font-weight-bold">
          Log ind
        </router-link>
      </p>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "../stores/auth";

const router = useRouter();
const route = useRoute();
const auth = useAuthStore();

const displayName = ref("");
const username = ref("");
const email = ref("");
const password = ref("");
const showPw = ref(false);
const error = ref("");

async function handleRegister() {
  error.value = "";
  try {
    await auth.register({
      email: email.value,
      username: username.value,
      password: password.value,
      displayName: displayName.value || undefined,
    });
    router.push(route.query.redirect || "/dashboard");
  } catch (e) {
    error.value = e.response?.data?.error || "Registrering fejlede";
  }
}
</script>
